import Vue from 'vue'
import App from './App.vue'
import router from './router'

Vue.config.productionTip = false

// ✅ 添加全局参数读取逻辑
function getQueryParam(name) {
	const url = new URL(window.location.href);
	return url.searchParams.get(name);
}

// ✅ 读取来自小程序传入的参数并挂载全局
const uid = getQueryParam('uid');
const is_shiming = getQueryParam('is_shiming');

Vue.prototype.$fromMiniProgram = {
	uid: uid || null,
	is_shiming: is_shiming || null
};



new Vue({
	router,
	render: h => h(App)
}).$mount('#app')